import { runIsolatedJob3cgv8kybs77yh as runIsolatedJob } from './runIsolatedJob.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createCleanupCallback(block) {
  return () => runIsolatedJob(block);
}
//region block: exports
export {
  createCleanupCallback as createCleanupCallback25lsm9rsfgs13,
};
//endregion

//# sourceMappingURL=createCleanupCallback.mjs.map
